
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/energia-solar-fotovoltaica-perguntas-frequentes",
      function () {
        return require("private-next-pages/energia-solar-fotovoltaica-perguntas-frequentes.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/energia-solar-fotovoltaica-perguntas-frequentes"])
      });
    }
  